import Road from './road.js';

function generateBeadRoadGraph(roundResults, rowCount, columnCount) {
    const data = roundResults.slice(-rowCount * columnCount);
    const result = Array(rowCount).fill(undefined);
    result.forEach((row, rowIndex, roadArray) => {
        roadArray[rowIndex] = Array(columnCount).fill(undefined);
        roadArray[rowIndex].forEach((column, columnIndex, roadRow) => {
            const dataIndex = columnIndex * rowCount + rowIndex;
            const oldResult = data[dataIndex];
            if (typeof oldResult !== 'undefined') {
                roadRow[columnIndex] = {
                    result: data[dataIndex].result,
                    gameResult: data[dataIndex].gameResult,
                    pairResult: data[dataIndex].pairResult,
                };
            }
        });
    });
    return result;
}
class BeadRoad extends Road {
    constructor(row, column, roundResults) {
        super(row, column, roundResults);
        this.row = row;
        this.column = column;
        this.roundResults = roundResults;
        this.array = generateBeadRoadGraph(roundResults, row, column);
    }
}

export {BeadRoad};


